import { Accordion, Container } from 'react-bootstrap';

export default function FaqSection() {
  return (
    <section className="py-5 bg-dark text-white" id="faq">
      <Container>
        <h2 className="mb-4 text-center">Preguntas Frecuentes</h2>
        <Accordion defaultActiveKey={null} alwaysOpen={false}>
          <Accordion.Item eventKey="0">
            <Accordion.Header>¿Para cuántas personas es Guanteo?</Accordion.Header>
            <Accordion.Body>
              Guanteo está diseñado exclusivamente para 2 jugadores, ideal para partidas intensas y dinámicas.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>¿Cuánto dura una partida?</Accordion.Header>
            <Accordion.Body>
              En promedio, una partida dura entre 25 y 45 minutos, dependiendo de la memoria (¡y estrategia!) de los jugadores.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>¿Es apto para todas las edades?</Accordion.Header>
            <Accordion.Body>
              El juego está recomendado para adultos mayores de 14 años. No tiene contenido inapropiado, pero requiere memoria y táctica.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>¿Qué incluye la caja del juego?</Accordion.Header>
            <Accordion.Body>
              El juego incluye 110 cartas: 2 Mazos (Rojo y Azul) idénticos de 45, 2 de ayuda por jugador, 16 de tablero y el reglamento. ¡Todo lo que necesitás para jugar en cualquier lado!
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>¿Dónde puedo conseguirlo?</Accordion.Header>
            <Accordion.Body>
              Podés comprar Guanteo en nuestra tienda online. 
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>
    </section>
  );
}
